import React from 'react';
import colors from '../../tailwind.colors';

export const Star = ({ value, width, height, fillColor, emptyColor }) => {
  let id = Math.random(1000);

  const renderValue = () => {
    return `${value * 100}%`;
  };

  return (
    <svg
      width={width ?? '26'}
      height={height ?? '25'}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={`grad-${id}`}>
          <stop
            offset={renderValue()}
            stopColor={fillColor ?? colors.secondary[400]}
          />
          <stop offset={renderValue()} stopColor={emptyColor ?? '#D4D8DC'} />
        </linearGradient>
      </defs>
      <path
        d="M12.7898 0.65625L16.928 8.30334L25.5779 9.82332L19.4866 16.071L20.6925 24.6562L12.7898 20.872L4.88538 24.6562L6.09124 16.071L0 9.82332L8.64991 8.30334L12.7898 0.65625Z"
        fill={`url(#grad-${id})`}
      />
    </svg>
  );
};
